var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Wer ist URS?")])],1),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Impressum")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }